import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0068',
    ecrans: ['00-2'],
    params:['?unocleint','?trmcleint','?ofacleint','?temcleint', '?isforage']
});
